import { types } from './actions';

const initialState = {
  filename: null,
  isModalOpen: false,
  shouldEnterThickness: false,
  shouldEnterUnits: false,
  similarFiles: [],
  thickness: null,
  currentUnits: null,
};

export default (state = initialState, action) => {
  const { payload } = action;
  switch (action.type) {
    case types.UPLOAD_DETAILS_MODAL_OPEN:
      return {
        ...state,
        filename: payload.filename,
        isModalOpen: true,
        shouldEnterThickness: payload.shouldEnterThickness,
        shouldEnterUnits: payload.shouldEnterUnits,
        similarFiles: payload.similarFiles,
        thickness: payload.thickness,
        currentUnits: payload.currentUnits ?? null,
      };
    case types.UPLOAD_DETAILS_MODAL_CLOSE:
    case types.UPLOAD_DETAILS_MODAL_CONFIRM:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export const getScope = (state) =>
  state.modules.common.modals.uploadDetailsModal;

export const getFilename = (state) => getScope(state).filename;

export const getIsModalOpen = (state) => getScope(state).isModalOpen;

export const getShouldEnterThickness = (state) =>
  getScope(state).shouldEnterThickness;

export const getShouldEnterUnits = (state) => getScope(state).shouldEnterUnits;

export const getSimilarFiles = (state) => getScope(state).similarFiles;

export const getThickness = (state) => getScope(state).thickness;

export const getCurrentUnits = (state) => getScope(state).currentUnits;
